/**
 * Bypass "click magnifier to show search bar" within the drawer
 */
function searchInDrawer() {
  const body = document.querySelector('body');
  const hamburgerMenuButton = document.querySelector('#Details-menu-drawer-container .header__icon--menu') ? document.querySelector('#Details-menu-drawer-container .header__icon--menu') : null;
  const searchBarContainer = document.querySelector('.menu-drawer .header__search > details') ? document.querySelector('.menu-drawer .header__search > details') : null;

  if (hamburgerMenuButton != null) {
    hamburgerMenuButton.onclick = (e) => {
      body.classList.toggle('overflow-hidden');
      if (searchBarContainer != null) {
        searchBarContainer.setAttribute('open', 'true');
      } else {
        console.error('No `searchBarContainer` found.');
      }
    }
  }
}

searchInDrawer();
window.addEventListener('load', (event) => {
  /**
   * Custom Modal
   */
  function ditModal() {
    const modals = document.querySelectorAll('.dit-modal');
    const modalTriggers = document.querySelectorAll('.dit-modal-trigger');
    const modalClosers = document.querySelectorAll('.dit-modal__closer');

    for (let i = 0; i < modalTriggers.length; i++) {
      modalTriggers[i].onclick = function () {
        modals[i].style.display = 'flex';
      }

      modalClosers[i].onclick = function () {
        modals[i].style.display = 'none';
      }
    }
  }

  ditModal();

  /**
   * Custom Tab
   */
  function ditTab() {
    const tabs = document.querySelectorAll('.dit-tab');
    const tabsButtons = document.querySelectorAll('.dit-tab__button');
    const tabsMobileMenu = document.querySelector('.dit-tab__mobile-menu');

    if (tabs.length > 0) {
      // Mobile dropdown menu
      tabsMobileMenu.addEventListener('change', function (e) {
        let option = this.options[this.selectedIndex];
        let targetID = option.value + '-tab';
        let targetElement = document.querySelector('#' + targetID);
        // Remove `is-active`
        tabs.forEach((tab) => {
          if (tab.classList.contains('is-active')) {
            tab.classList.remove('is-active')
          }
        })

        // Add `is-active`
        targetElement.classList.add('is-active');
      });

      // Desktop tab buttons
      tabsButtons.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          let targetID = btn.getAttribute('data-target');
          let targetElement = document.querySelector('#' + targetID);

          // Remove `is-active` on other buttons
          tabsButtons.forEach((button) => {
            if (button.classList.contains('is-active')) {
              button.classList.remove('is-active')
            }
          })
          // Remove `is-active` on all tabs
          tabs.forEach((tab) => {
            if (tab.classList.contains('is-active')) {
              tab.classList.remove('is-active')
            }
          })
          // Add `is-active` on clicked button and active tab          
          btn.classList.add('is-active');
          targetElement.classList.add('is-active');
        })
      })
    }
  }

  ditTab();

  document.addEventListener("cncwidgetloaded", function (e) {
    console.info('cncwidgetloaded is loaded');
  });

});